import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as datepicker from "@elements/datepicker";
datepicker.init();

import * as datepickerRange from "@elements/datepicker-range";
datepickerRange.init();


import * as imageSlider from './scripts/image-slider';
imageSlider.init();

import * as formValidation from '@elements/form-validation';
formValidation.init();
